<template>
    <b-card>
        <b-card-header>
            <h4 class="title">
                ویرایش اتاق جلسات
            </h4>
        </b-card-header>
        <b-card-body>
            <validation-observer
                    #default="handleSubmit"
                    ref="refFormObserver"
            >
                <b-form @submit.prevent>
                    <b-row>
                        <b-col md="4">
                            <validation-provider
                                    #default="validationContext"
                                    name="نام اتاق"
                                    rules="required"
                            >
                                <b-form-group>
                                    <label for="name">
                                        <feather-icon
                                                icon="FeatherIcon"
                                        />
                                        نام اتاق
                                    </label>
                                    <b-form-input
                                            id="name"
                                            v-model="name"
                                            placeholder="نام اتاق را وارد نمایید"
                                            :state="getValidationState(validationContext)"
                                            trim
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <label for="is_active"/>
                                <b-form-checkbox
                                        id="is_active"
                                        v-model="is_active"
                                        checked="true"
                                        name="check-button"
                                        class="custom-control-success"
                                        switch
                                >
                                    فعال
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>

                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-form-group
                                    label="فعال از ساعت"
                                    description="رزرو اتاق قبل از این ساعت امکانپذیر نیست"
                            >
                                <date-picker
                                        v-model="open_at"
                                        type="time"
                                        display-format="HH:mm"
                                        format="HH:mm"
                                        placeholder="لطفاً ساعت پیش فرض را وارد کنید "
                                        clearable
                                />

                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group
                                    label="فعال تا ساعت"
                                    description="رزور اتاق بعد از این ساعت امکانپذیر نیست."
                            >
                                <date-picker
                                        v-model="close_at"
                                        type="time"
                                        :min="open_at"
                                        display-format="HH:mm"
                                        placeholder="لطفاً ساعت پیش فرض را وارد کنید "
                                        format="HH:mm"
                                        clearable
                                />

                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <b-form-group
                                    label="توضیحات اتاق"
                            >
                                <div>
                                    <quill-editor
                                            v-model="description"
                                            :options="editorOption"
                                    />
                                </div>

                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
            <button
                    class="btn btn-info mt-2"
                    @click="updateUser"
            >
                ویرایش اتاق جلسات
            </button>
        </b-card-body>
    </b-card>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BInputGroup,
    BInputGroupAppend, BFormCheckbox, BFormInvalidFeedback,
} from 'bootstrap-vue'
import {ValidationProvider, ValidationObserver, localize} from 'vee-validate'
import farsi from 'vee-validate/dist/locale/fa'
import VSelect from 'vue-select'
import formValidation from '@core/comp-functions/forms/form-validation'
import {required} from '@core/utils/validations/validations'
import { quillEditor } from 'vue-quill-editor'

export default {
    name: 'RoomUpdate',
    components: {
        VSelect,
        ValidationProvider,
        ValidationObserver,
        BFormInvalidFeedback,
        BFormCheckbox,
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BForm,
        BFormGroup,
        BFormInput,
        BOverlay,
        BInputGroup,
        BInputGroupAppend,
        quillEditor,
    },
    data() {
        return {
            name: '',
            is_active: true,
            open_at: null,
            close_at: null,
            description: null,
            editorOption: {
                theme: 'snow',
                placeholder: 'متن پیام را وارد کنید',
            },
        }
    },
    created() {
        localize('fa', {
            messages: farsi.messages,
        })
    },
    mounted() {
        this.getRoom()
    },
    methods: {
        getRoom() {
            this.$http.get(`rooms/${this.$route.params.id}`)
                .then(({data}) => {
                    if (data.status) {
                        this.name = data.room.name
                        this.is_active = !! data.room.is_active
                        this.close_at = data.room.close_at
                        this.open_at = data.room.open_at
                        this.description = data.room.description
                    } else {
                        this.$bvToast.toast(data.message ?? 'دریافت اتاق جلسات  با خطا مواجه شد', {
                            title: 'خطا در دریافت اطلاعات',
                            toaster: 'b-toaster-top-right',
                            variant: 'danger',
                        })
                    }
                })
                .catch(error => {
                    this.$bvToast.toast(error.response.data.message ?? error.message, {
                        title: 'خطا در دریافت اطلاعات',
                        toaster: 'b-toaster-top-right',
                        variant: 'danger',
                    })
                })
        },
        updateUser() {
            this.$refs.refFormObserver.validate()
                .then(success => {
                    if (success) {
                        this.$http.put(`rooms/${this.$route.params.id}`, {
                            name: this.name,
                            is_active: this.is_active,
                            open_at: this.open_at,
                            close_at: this.close_at,
                            description: this.description,
                        })
                            .then(({data}) => {
                                if (data.status) {
                                    this.$bvToast.toast('اتاق جلسات  با موفقیت ویرایش شد', {
                                        title: 'موفقیت',
                                        toaster: 'b-toaster-top-right',
                                        variant: 'success',
                                    })
                                } else {
                                    this.$bvToast.toast(data.message ?? 'در ایجاد اتاق جلسات  خطایی رخ داده', {
                                        title: 'حطا',
                                        toaster: 'b-toaster-top-right',
                                        variant: 'danger',
                                    })
                                }
                            })
                            .catch(error => {
                                this.$bvToast.toast(error.response.data.message ?? error.message, {
                                    title: 'خطا در دریافت اطلاعات',
                                    toaster: 'b-toaster-top-right',
                                    variant: 'danger',
                                })
                            })
                    }
                })
        },
    },
    setup() {
        const {
            getValidationState,

        } = formValidation(name)

        return {
            getValidationState,
        }
    },
}
</script>

<style>

</style>
